<template>
  <section class="d-flex flex-column mt-3 mx-xs-0 mx-xxs-3">
    <h5>{{ $t('product.license', {product: this.globalResources.productTranslation.Single}) }}</h5>
    <p class="font-weight-light" v-html="$t('product.licenseDescription', { title: title, product: this.globalResources.productTranslation.Single })" />
    <b-button to="/ContactUs" v-if="tenantDesignConfig.general.Skin === 'cloob' ||
      tenantDesignConfig.general.Skin === 'jabe'" variant="primary" class="col-sm-2 mx-sm-auto col-xxs-12">
      {{ $t('product.contactUs') }}
    </b-button>
    <b-button to="/ContactUs" v-else variant="outline-success" size="lg" class="col-lg-3 col-md-4 col-sm-5 mx-md-0 mx-sm-auto col-xxs-12">
      {{ $t('product.contactUs') }}
    </b-button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductLicense',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      tenantDesignConfig: 'tenantDesign/config'
    })
  }
}
</script>
